import { motion, AnimatePresence } from "framer-motion";
import React, { useEffect, useRef, useState } from "react";

export default function Dropdown({
  children,
  addClass = "",
  additional = "",
  btnInner,
  containerSize = "",
}) {
  const wrapper = useRef(null);
  const [active, setActive] = useState(false);

  const toggleActive = () => {
    setActive(!active);
  };

  useEffect(() => {
    const windowClick = ({ target }) => {
      if (!wrapper.current.contains(target)) setActive(false);
    };

    if (active) window.addEventListener("click", windowClick);
    else window.removeEventListener("click", windowClick);

    return () => window.removeEventListener("click", windowClick);
  }, [active]);

  const clickListener = React.useCallback((e) => {
    const className = e.target.classList[0];
    if (!className || !className.startsWith("account")) setActive(false);
    if (className === "account__list-link") setActive(false);
  }, []);

  useEffect(() => {
    if (active) {
      setTimeout(() => document.addEventListener("click", clickListener), 100);
    } else {
      document.removeEventListener("click", clickListener);
    }
    return () => document.removeEventListener("click", clickListener);
  }, [active]);
  return (
    <div className={"dropdown " + additional} ref={wrapper}>
      <button
        className={"dropdown__button " + addClass + (active ? "active" : "")}
        onClick={toggleActive}
        type="button"
      >
        {btnInner}
      </button>
      <AnimatePresence>
        {active === true && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.2 }}
            exit={{ opacity: 0 }}
            className={`dropdown__menu  ${
              active ? "active" : ""
            } ${containerSize}`}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
